import { observable, action, computed } from "mobx";
import { persist } from "mobx-persist";
import axios from "axios";
import { getMunicipalityMapLayers } from "services/api";

/**
 * model used to control the layer of the maps
 * maplist is a json with al possible layers
 * when changing the activemapindex the map will be rerendered
 *
 */
class MapLayerModel {
  constructor() {
    this.loadMaps();
  }

  @observable
  maps = [];

  @observable
  overlays = [];

  baseOverlays = [];

  @persist
  @observable
  activeMapIndex = 0;

  @persist
  @observable
  activeOverlayIndex = -1;

  @action
  loadMaps = async () => {
    try {
      const {
        data: { basemaps, overlays = [] },
      } = await axios.get("/config/maps.json");
      this.baseOverlays = overlays;

      if (basemaps && this.activeMapIndex >= basemaps.length) {
        this.activeMapIndex = 0;
      }
      // const mapLayers = await getMunicipalityMapLayers();
      this.maps = basemaps;
      this.overlays = [...this.baseOverlays];

      if (overlays && this.activeOverlayIndex >= this.overlays.length) {
        this.activeOverlayIndex = -1;
      }
    } catch (error) {
      console.log("ERROR::", error.toString());
    }
  };

  @action
  setActiveMapIndex = (index) => {
    this.activeMapIndex = index;
  };

  @action
  setActiveOverlayIndex = (index) => {
    this.activeOverlayIndex = index;
  };

  @action
  resetMunicipalityMapLayers = async () => {
    const mapLayers = await getMunicipalityMapLayers();
    this.overlays = [...this.baseOverlays, ...mapLayers];
    if (this.activeOverlayIndex >= this.overlays.length) {
      this.activeOverlayIndex = -1;
    }
  };

  @computed
  get activeMap() {
    return this.maps[this.activeMapIndex];
  }

  @computed
  get activeOverlay() {
    return this.overlays?.[this.activeOverlayIndex];
  }
}

export default MapLayerModel;
